import { FC } from 'react';
import { getLogoUrl } from 'utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faPlane } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { OutboundModel, Pair } from 'ts/package/interfaces/PackageDetails';
import { onImageLoadError } from 'utils/package';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import { dateFormat } from 'utils/ui';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface TicketDetailsProps {
  pair: Pair;
  bound: OutboundModel;
  type: string;
}

const TicketDetails: FC<TicketDetailsProps> = ({ bound, type = 'departure', pair }) => {
  const [t] = useTranslation();
  const seats = parseInt(type === 'return' ? pair.toSeats : pair.fromSeats);
  const remark = type === 'return' ? pair.toRemark : pair.fromRemark;

  return (
    <div className="default-shadow flight-details-item flight-details-ticket package-ticket">
      <div className={'title-header-grey' + (type === 'departure' ? ' ticket-header-forward' : '')}>
        <FontAwesomeIcon className="text-sm mr-5 text-contrast" icon={faPlane} />{' '}
        {t(type === 'return' ? 'flight.return' : 'flight.departure')}
      </div>
      <div className="ticket-details-info">
        <div className="item">
          <span className="city text-bold">{bound.departureIATA}</span>
          <span className="time text-bold">
            {dateFormat(`${bound.date}T${bound.depTime}`, 'HH:mm')}
          </span>
          <span className="day">
            {dateFormat(`${bound.date}T${bound.depTime}`, 'EEE - dd MMMM, yyyy')}
          </span>
        </div>
        <div className="item">
          <span className="city text-bold">{bound.arrivalIATA}</span>
          <span className="time text-bold">
            {dateFormat(`${bound.date}T${bound.arrTime}`, 'HH:mm')}
          </span>
          <span className="day">
            {dateFormat(`${bound.date}T${bound.arrTime}`, 'EEE - dd MMMM, yyyy')}
          </span>
        </div>
        <div className="item">
          <span className="flex-center">
            <img
              src={getLogoUrl(blobUrl, bound.airline)}
              alt={bound.airline}
              onError={(e) => onImageLoadError(e, undefined)}
            />
            <span className="ticket-airline-code text-xxs">
              {bound.airline} {bound.flightNumber}
            </span>
          </span>
        </div>
        <div className="item">
          <Tooltip children={<FontAwesomeIcon icon={faClock} />} content={t('filter.duration')} />
          <span className="time text-bold">{bound.flightDuration}</span>
          {seats < 5 && (
            <span className="text-bold text-xsm">
              {t('flight.seats_available_up')} {seats}
            </span>
          )}
        </div>
      </div>
      <div className="text-sm">
        <span className="text-contrast">{t('notes')}: </span>
        <span>{remark}</span>
      </div>
    </div>
  );
};

export default withErrorBoundary(TicketDetails, 'TicketDetails');
